import { post2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { RestaurantTable } from "@/shared/utils/interfaces";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const useRestaurantTableMutation = (restaurantId: number) => {
  const queryClient = useQueryClient();
  const branchId = useBranchId();
  const { t } = useTranslation("");
  const mutation = useMutation({
    onSuccess: () => {
      toast.success(t("success.create"));
      queryClient.refetchQueries({
        queryKey: ["restaurantMap", branchId, restaurantId],
        exact: true,
      });
    },
    mutationFn: (table: RestaurantTable) =>
      post2(
        `/internal/secure/pos/v1/tables/${branchId}/${restaurantId}`,
        table
      ),
  });
  return mutation;
};

export default useRestaurantTableMutation;
